import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TableContainer,
    CircularProgress,
} from "@mui/material";
import { getMethod } from "../../../../services/apiService";
import search from "../../../../assets/images/icon/search.svg"
import SearchIcon from '@mui/icons-material/Search';
interface LicenseData {
    platformLicense: {
        key: string;
        partner: string;
        data: {
            name: string;
            quantity: number;
            createdTime: number;
            activationTime: number;
            expiryTime: number;
            status: number;
            licenseType: number;
            analyticType: number;
        };
    };
    countData: {
        total: number;
        active: number;
        available: number;
    };
}



const tableHeaders = [
    { label: "Feature", key: "feature" },
    { label: "Quantity", key: "quantity" },
    { label: "Available", key: "available" },
    { label: "Active", key: "active" },
    { label: "Expiry Date", key: "expiryDate" },
]



function PlatformAvailableLicense() {
    const [licenseData, setLicenseData] = useState<any[]>([]);
    const [filteredData, setFilteredData] = useState<LicenseData[]>([]);
    const [loader, showLoader] = useState(true);
    const hasFetched = useRef(false);


    
    useEffect(() => {
        if (!hasFetched.current) {
            fetchAvailableLicenseList();
            hasFetched.current = true;
        }
    }, []);


    
    const fetchAvailableLicenseList = async () => {
        const resp = await getMethod(`platform/license/vf2`);
        if (resp?.data?.code === 200) {
            setFilteredData(resp?.data?.result);
            setLicenseData(resp?.data?.result);
            showLoader(false);
        } else {
            showLoader(false);
        }
    };


    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value.toLowerCase();
        const filtered = licenseData.filter((item) => {
            const { name } = item?.platformLicense?.data;
            const { available } = item?.countData;

            return (
                name.toLowerCase().includes(searchText) ||
                available.toString().includes(searchText)
            );
        });
        setFilteredData(filtered);
    }


    return (
        <>
            <Box sx={{ display: "flex", alignContent: "space-between", justifyContent: "space-between", gap: "32px", paddingBottom: "35px" }}>
                <div
                    style={{
                        width: 468,
                        height: 41,
                        padding: 12,
                        borderRadius: 30,
                        border: "1px solid #5a5f60",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "#1F2F34",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {/* <img
                            src={search}
                            alt="Search Icon"
                            style={{ cursor: "pointer" }}
                        /> */}
                        <SearchIcon style={{ cursor: "pointer" }} />
                        <input
                            onChange={handleSearch}
                            placeholder="Search by feature, availability."
                            style={{
                                background: "#1F2F34",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                marginLeft: 8,
                                color: "#FFF",
                                width: 368,
                            }}
                        />
                    </div>
                </div>
            </Box>


            <TableContainer component={Paper} sx={{ backgroundColor: "#192529", padding: "1rem" }}>
                <Table sx={{ backgroundColor: "#192529", border: "1px solid #313838" }}>
                    {/* Table Header */}
                    <TableHead>
                        <TableRow style={{ borderBottom: "2px solid #313838" }}>
                            {tableHeaders.map((header) => (
                                <TableCell
                                    key={header.key}
                                    sx={{
                                        color: "#E2E3E3",
                                        borderColor: "#313838",
                                        fontWeight: "500",
                                        fontSize: "16px",
                                    }}
                                >
                                    {header.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                        {filteredData?.length > 0 ? (
                            filteredData?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {item?.platformLicense?.data?.name}
                                    </TableCell>

                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {item?.countData?.total}
                                    </TableCell>

                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {item?.countData?.available}
                                    </TableCell>

                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {item?.countData?.active}
                                    </TableCell>

                                    <TableCell sx={{ color: "#B4B7B8", borderColor: "#313838" }}>
                                        {
                                            item?.platformLicense?.data?.expiryTime
                                                ? new Date(item.platformLicense.data.expiryTime).toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })
                                                : "N/A"
                                        }
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow sx={{ background: '#192529' }}>
                                <TableCell sx={{ color: '#E2E3E3', borderColor: '#313838', margin: '0', textAlign: 'center' }} colSpan={9}>
                                    {loader ? (
                                        <CircularProgress color="primary" />
                                    ) : (
                                        "No Data!"
                                    )}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default PlatformAvailableLicense